import { Injector } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { of, isObservable } from 'rxjs';
import { AppConfig } from '@awp/core/config';
import { tap, shareReplay } from 'rxjs/operators';
var ContentHttpInterceptor = /** @class */ (function () {
    function ContentHttpInterceptor(injector) {
        this.injector = injector;
        this._cache = new Map();
    }
    ContentHttpInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        if (request.method !== 'GET'
            || request.url.startsWith('./assets')
            || !request.url.startsWith(this.appConfig.CMS_ROOT_API_URL)) {
            return next.handle(request);
        }
        var cachedResponse = this._cache.get(request.url);
        if (cachedResponse != null) {
            return isObservable(cachedResponse)
                ? cachedResponse
                : of(cachedResponse);
        }
        var requestHandle = next.handle(request)
            .pipe(tap(function (event) {
            if (event instanceof HttpResponse) {
                _this._cache.set(request.url, event);
            }
        }), shareReplay(1));
        this._cache.set(request.url, requestHandle);
        return requestHandle;
    };
    Object.defineProperty(ContentHttpInterceptor.prototype, "appConfig", {
        get: function () {
            if (this._appConfig == null) {
                this._appConfig = this.injector.get(AppConfig);
            }
            return this._appConfig;
        },
        enumerable: true,
        configurable: true
    });
    return ContentHttpInterceptor;
}());
export { ContentHttpInterceptor };
